import { useEffect, useState } from 'react';
import { Paper } from '@mui/material';

import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import PolylineRoundedIcon from '@mui/icons-material/PolylineRounded';
import PolylineOutlinedIcon from '@mui/icons-material/PolylineOutlined';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import LocationSearchingRoundedIcon from '@mui/icons-material/LocationSearchingRounded';

import './MapFilterOptions.scss';

function MapFilterOptions({ handleShowPins, handleShowPolygons, handleShowHeatmap,
    handleClickCurrentLocation }) {

  const [pinFilterSelected, setPinFilterSelected] = useState(true);
  const [polygonFilterSelected, setPolygonFilterSelected] = useState(false);
  const [heatmapFilterSelected, setHeatmapFilterSelected] = useState(false);
  const [currentLocationSelected, setCurrentLocationSelected] = useState(false);

  let clickCurrentLocationTimeout = null;

  useEffect(() => {
    return (() => {
      clearTimeout(clickCurrentLocationTimeout);
    })
  }, [clickCurrentLocationTimeout]);

  function handlePinFilterClick() {
    handleShowPins?.(!pinFilterSelected);
    setPinFilterSelected(!pinFilterSelected);
  }

  function handlePolygonFilterClick() {
    handleShowPolygons?.(!polygonFilterSelected);
    setPolygonFilterSelected(!polygonFilterSelected);
  }

  function handleHeatmapFilterClick() {
    handleShowHeatmap?.(!heatmapFilterSelected);
    setHeatmapFilterSelected(!heatmapFilterSelected);
  }

  function handleCurrentLocationClick() {
    handleClickCurrentLocation?.(true);
    setCurrentLocationSelected(true);

    clickCurrentLocationTimeout = setTimeout(() => {
      handleClickCurrentLocation?.(false);
      setCurrentLocationSelected(false);
    }, 1000);
  }

  return (
    <Paper className="map-filter-options">
      <div className="filter-option">
        {!pinFilterSelected ? (
          <FmdGoodOutlinedIcon
            className="not-selected"
            onClick={handlePinFilterClick}
          />
        ) : (
          <FmdGoodRoundedIcon
            className="selected"
            onClick={handlePinFilterClick}
          />
        )}
      </div>
      <div className="filter-option">
        {!polygonFilterSelected ? (
          <PolylineOutlinedIcon
            className="not-selected"
            onClick={handlePolygonFilterClick}
          />
        ) : (
          <PolylineRoundedIcon
            className="selected"
            onClick={handlePolygonFilterClick}
          />
        )}
      </div>
      <div className="filter-option">
        {!heatmapFilterSelected ? (
          <LocalFireDepartmentOutlinedIcon
            className="not-selected"
            onClick={handleHeatmapFilterClick}
          />
        ) : (
          <LocalFireDepartmentIcon
            className="selected"
            onClick={handleHeatmapFilterClick}
          />
        )}
      </div>
      <div className="filter-option">
        {!currentLocationSelected ? (
          <LocationSearchingRoundedIcon
            className="not-selected"
            onClick={handleCurrentLocationClick}
          />
        ) : (
          <MyLocationIcon
            className="selected"
            onClick={handleCurrentLocationClick}
          />
        )}
      </div>
    </Paper>
  );
}

export default MapFilterOptions;
